import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="file-upload"
export default class extends Controller {
  static targets = ["fileInput", "fileName"];

  selectFile() {
    if (this.fileInputTarget.files.length > 0) {
      this.element.requestSubmit();
    } else {
      console.log("No file selected.");
    }
  }

  chooseFile() {
    this.fileInputTarget.addEventListener("change", () => {
      const fileName = this.fileInputTarget.files[0]
        ? this.fileInputTarget.files[0].name
        : "No file chosen";
      this.fileNameTarget.textContent = fileName;
    });
  }
}
